// extracted by mini-css-extract-plugin
export default {"tag":"components-TacticalFlag-styles__tag--gv1UK","small":"components-TacticalFlag-styles__small--m5Psg","large":"components-TacticalFlag-styles__large--CGcTm"};